import { BATTERY_POWERED_DEVICE_TYPES } from 'services/BatteryHelper';

export function getDeviceTypesForTrigger(template) {
    const field = template && template.trigger && template.trigger.field;
    if (!field) return [];

    const connection = template.trigger.connection;

    switch (field) {
        case 'touch':
            return ['touch', 'temperature', 'humidity', 'proximity', 'waterDetector', 'touchCounter', 'proximityCounter'];
        case 'touchCount':
            return ['touch', 'temperature', 'humidity', 'proximity', 'waterDetector'];
        case 'temperature':
            return ['temperature', 'humidity', 'co2'];
        case 'relativeHumidity':
            return ['humidity', 'co2'];
        case 'objectPresent':
            return ['proximity'];
        case 'contact':
            return ['contact'];
        case 'contactCount':
            return ['contact'];
        case 'proximityCount':
            return ['proximity'];
        case 'waterPresent':
            return ['waterDetector'];
        case 'co2':
            return ['co2'];
        case 'differentialPressure':
            return ['differentialPressure'];
        case 'motion':
            return ['motion'];
        case 'deskOccupancy':
            return ['deskOccupancy'];
        case 'connectionStatus':
            switch (connection) {
                case 'CLOUD_CONNECTOR_OFFLINE': return ['ccon'];
                case 'SENSOR_OFFLINE': return ['touch', 'temperature', 'humidity', 'proximity', 'waterDetector', 'touchCounter', 'proximityCounter', 'co2', 'motion', 'deskOccupancy', 'contact', 'analog', 'differentialPressure'];
                default: return [];
            }
        case 'batteryStatus':
            return BATTERY_POWERED_DEVICE_TYPES;
        default:
            return [];
    }
}

export function projectHasSensors(project) {
    return project && project.sensorCount > 0;
}

export function projectHasTimezone(project) {
    return !!(project && project.location && project.location.timeLocation);
}

export function projectMatchesLabels(project, labels) {
    if (!labels) return true;
    return Object.entries(labels).every(([key, value]) => {
        if (key.startsWith('-')) {
            const actualKey = key.substring(1);
            if (value === '') {
                return !project.labels || !Object.prototype.hasOwnProperty.call(project.labels, actualKey);
            }
            return !project.labels || project.labels[actualKey] !== value;
        }

        if (!project.labels) return false;

        if (value === '') {
            return Object.prototype.hasOwnProperty.call(project.labels, key);
        }
        return project.labels[key] === value;
    });
}

export function getProjectsInScope(template, allProjects) {
    const projects = allProjects || [];
    if (!template || !template.scope || template.scope.type !== 'PROJECT_LABELS') {
        return projects;
    }
    return projects.filter(p => projectMatchesLabels(p, template.scope.labels));
}
